/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './treatment-regimen-investigation.reducer';

export const TreatmentRegimenInvestigationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const treatmentRegimenInvestigationEntity = useAppSelector(state => state.treatmentRegimenInvestigation.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="treatmentRegimenInvestigationDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.treatmentRegimenInvestigation.detail.title">TreatmentRegimenInvestigation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.treatmentRegimenInvestigation.id">Id</Translate>
            </span>
          </dt>
          <dd>{treatmentRegimenInvestigationEntity.id}</dd>
          <dt>
            <span id="cycleNumber">
              <Translate contentKey="tinyMedicRestApp.treatmentRegimenInvestigation.cycleNumber">Cycle Number</Translate>
            </span>
          </dt>
          <dd>{treatmentRegimenInvestigationEntity.cycleNumber}</dd>
          <dt>
            <span id="associationType">
              <Translate contentKey="tinyMedicRestApp.treatmentRegimenInvestigation.associationType">Association Type</Translate>
            </span>
          </dt>
          <dd>{treatmentRegimenInvestigationEntity.associationType}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.treatmentRegimenInvestigation.active">Active</Translate>
            </span>
          </dt>
          <dd>{treatmentRegimenInvestigationEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.treatmentRegimenInvestigation.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{treatmentRegimenInvestigationEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.treatmentRegimenInvestigation.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{treatmentRegimenInvestigationEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.treatmentRegimenInvestigation.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{treatmentRegimenInvestigationEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.treatmentRegimenInvestigation.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{treatmentRegimenInvestigationEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentRegimenInvestigation.plan">Plan</Translate>
          </dt>
          <dd>{treatmentRegimenInvestigationEntity.plan ? treatmentRegimenInvestigationEntity.plan.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentRegimenInvestigation.regimen">Regimen</Translate>
          </dt>
          <dd>{treatmentRegimenInvestigationEntity.regimen ? treatmentRegimenInvestigationEntity.regimen.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentRegimenInvestigation.cycle">Cycle</Translate>
          </dt>
          <dd>{treatmentRegimenInvestigationEntity.cycle ? treatmentRegimenInvestigationEntity.cycle.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentRegimenInvestigation.metaDiagnosis">Meta Diagnosis</Translate>
          </dt>
          <dd>{treatmentRegimenInvestigationEntity.metaDiagnosis ? treatmentRegimenInvestigationEntity.metaDiagnosis.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/treatment-regimen-investigation" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/treatment-regimen-investigation/${treatmentRegimenInvestigationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TreatmentRegimenInvestigationDetail;
